import { Typography } from '@mui/material'

function ColorByStatus({ error = false, message = '' }) {
  return (
    <Typography
      variant="body1"
      component="div"
      className={error ? 'text-error' : 'text-success'}
    >
      {message}
    </Typography>
  )
}

export default ColorByStatus
